import styled, { css } from "styled-components";
import { IStyledTasksProps } from "./interfaces";

export const StyledDivider = styled.div`
    display: flex;
    ${p =>
        p.theme.xs(css`
            flex-direction: column;
        `)}
`;

export const AsideAdSense = styled.div`
    margin-top: -20px;
    
    ${p =>
        p.theme.sm.min(css`
            width: 300px;
            margin-left: 20px;
        `)}
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
`;

export const BelowAdSense = styled.div`
    margin-top: -20px;
    margin-bottom: 20px;
`;

export const AboveMobileAdSense = styled.div`
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
    display: flex;
    justify-content: center;
    margin: 0 -20px 20px;
`;

export const StyledTasks = styled.div<IStyledTasksProps>`
    min-height: calc(100vh - 420px);
    margin-bottom: ${p => (p.publicView ? 20 : 0)}px;
    flex: 1;
    margin-top: -12px;
`;

export const AddTaskHolder = styled.div`
    text-align: center;
    ${p =>
        p.theme.xs(css`
            button,
            a {
                display: block;
                width: 100%;
                margin-left: 0 !important;
            }
        `)}
`;

export const EmptyPlan = styled.div`
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h3 {
        text-align: center;
    }
`;

export const NoPreview = styled.p`
    text-align: center;
`;

